// BackendPageForAbout.js — "About" page (placeholder for now).

import React, { useContext } from 'react';
import { ConfigContext } from '../../App';
import { PlaceholderPage } from '../../myReactLib/MainBlocks';

function BackendPageForAbout() {
  const { config, homepageData, contactData } = useContext(ConfigContext);
  if (!homepageData) return null;
  return (
    <PlaceholderPage
      title="About"
      menuBar={homepageData.menu_bar}
      prefix={config.PREFIX}
      config={config}
      contactData={contactData}
      footer={homepageData.footer}
    />
  );
}

export default BackendPageForAbout;
